/*
 * Fig & Bloom - product card image swiper.
 *
 * This was previously emitted inline once per product card, 50 times on a collection page,
 * 18,890 bytes each. Every copy was byte-identical because nothing here is per-card: the
 * initialiser selects globally via querySelectorAll('.product-card-swiper:not(.swiper-initialized)')
 * and reads per-product values at runtime from data-product-id / data-product-url. It was
 * written as a global initialiser and mistakenly placed inside the per-card snippet.
 *
 * Loaded once per page from snippets/product-card-scripts.liquid. The ajaxProductGridUpdated
 * and shopify:section:load handlers are retained: they are what re-initialises lazily loaded
 * cards, and the infinite-scroll grid depends on them.
 */
(function () {
  if (window.__fbProductCardSwiperLoaded) return;
  window.__fbProductCardSwiperLoaded = true;

// Enhanced Product Card Swiper with Desktop Click/Drag Disabled
(function() {
  // Wait for DOM and check for Swiper
  function waitForSwiper(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
    } else {
      console.log('Swiper not loaded, using fallback slider');
      initializeFallbackSlider();
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    // Try to load Swiper if not already loaded
    if (typeof Swiper === 'undefined') {
      loadSwiperLibrary(function() {
        initializeProductCardSwipers();
      });
    } else {
      initializeProductCardSwipers();
    }
    
    // Re-initialize on AJAX content updates
    document.addEventListener('ajaxProductGridUpdated', function() {
      waitForSwiper(initializeProductCardSwipers);
    });
    
    // Re-initialize when Shopify sections are loaded
    document.addEventListener('shopify:section:load', function() {
      waitForSwiper(initializeProductCardSwipers);
    });
  });

  // Swiper is loaded globally via theme.liquid — just run the callback
  function loadSwiperLibrary(callback) {
    if (typeof Swiper !== 'undefined') {
      if (callback) callback();
    } else {
      console.error('Swiper not available globally, using fallback');
      initializeFallbackSlider();
    }
  }

  // Check if device is mobile
  function isMobileDevice() {
    return window.innerWidth < 768;
  }

  // Detect if device has touch capability
  function isTouchDevice() {
    return ('ontouchstart' in window) || 
           (navigator.maxTouchPoints > 0) || 
           (navigator.msMaxTouchPoints > 0);
  }

  // Main initialization function
  function initializeProductCardSwipers() {
    // Find all product card swipers that haven't been initialized
    const swiperElements = document.querySelectorAll('.product-card-swiper:not(.swiper-initialized)');
    
    swiperElements.forEach((element) => {
      const productId = element.getAttribute('data-product-id');
      const productUrl = element.getAttribute('data-product-url');
      const slideCount = element.querySelectorAll('.swiper-slide').length;
      const wrapper = element.closest('.product-card-media-wrapper');
      const container = element.closest('.product-card-swiper-container');
      
      // Only initialize if there are multiple slides
      if (slideCount <= 1) {
        container.style.display = 'none';
        return;
      }
      
      // Detect touch device and add class
      const isTouch = isTouchDevice();
      const isMobile = isMobileDevice();
      
      if (isTouch) {
        container.classList.add('touch-device');
        wrapper.classList.add('touch-device');
      } else {
        container.classList.add('no-touch-device');
        wrapper.classList.add('no-touch-device');
      }
      
      // Function to update sliding line indicator (mobile only)
      function updateProgressLine(swiperInstance) {
        // Only update on mobile
        if (!isMobile) return;
        
        const progressLine = element.querySelector('.swiper-progress-line-fill');
        if (progressLine) {
          const totalSlides = swiperInstance.slides.length;
          const currentIndex = swiperInstance.activeIndex;
          const indicatorWidth = 100 / totalSlides;
          progressLine.style.width = indicatorWidth + '%';
          progressLine.style.transform = `translateX(${(currentIndex * 100)}%)`;
        }
      }
      
      // Different configuration based on device type
      const swiperConfig = {
        // Core parameters
        // Card columns can be fractional pixels. Match the CSS slide width,
        // not Swiper's rounded clientWidth, so adjacent images cannot bleed in.
        width: element.getBoundingClientRect().width,
        slidesPerView: 1,
        // A hidden 1px gutter prevents subpixel antialiasing from sampling
        // the neighbouring image at the clipping edge. Visible layout is unchanged.
        spaceBetween: 1,
        loop: !isMobile, // Infinite scroll for desktop/tablet
        speed: 400,
        
        // Touch/drag parameters - CONDITIONAL BASED ON DEVICE
        touchRatio: isTouch ? 1 : 0, // Disable dragging on non-touch devices
        touchAngle: isTouch ? 45 : 0,
        grabCursor: isTouch, // Only show grab cursor on touch devices
        threshold: isTouch ? 10 : 1000, // High threshold on non-touch to prevent accidental swipes
        allowTouchMove: isTouch, // Completely disable touch/drag on non-touch devices
        simulateTouch: isTouch, // Disable mouse drag simulation on non-touch devices
        
        // Mouse wheel (disabled)
        mousewheel: false,
        
        // Keyboard navigation (disabled to prevent accidental navigation)
        keyboard: false,
        
        // Click handling
        preventClicks: false,
        preventClicksPropagation: false,
        slideToClickedSlide: false,
        
        // Hide default pagination
        pagination: false,
        
        // Navigation arrows (only functional on desktop/tablet)
        navigation: !isMobile ? {
          nextEl: element.querySelector('.swiper-button-next'),
          prevEl: element.querySelector('.swiper-button-prev'),
        } : false,
        
        // Events
        on: {
          init: function() {
            // Update progress line on init (mobile only)
            updateProgressLine(this);
            
           // Add click handler to slides for product navigation
// Add click handler to slides for product navigation
element.querySelectorAll('.swiper-slide').forEach(slide => {
  
  // Check if quick view toggle is enabled via data attribute
  const productCard = element.closest('.product-grid-item');
  const isQuickViewEnabled = productCard && productCard.getAttribute('data-quickview-enabled') === 'true';
  
  if (isTouch) {
    // Touch device behavior
    slide.style.cursor = 'pointer';
    
    // Track if we're swiping
    let isSwiping = false;
    let startX = 0;
    let startY = 0;
    
    slide.addEventListener('touchstart', function(e) {
      isSwiping = false;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    });
    
    slide.addEventListener('touchmove', function(e) {
      const diffX = Math.abs(e.touches[0].clientX - startX);
      const diffY = Math.abs(e.touches[0].clientY - startY);
      if (diffX > 10 || diffY > 10) {
        isSwiping = true;
      }
    });
    
    slide.addEventListener('touchend', function(e) {
      // If not swiping, trigger the appropriate action
      if (!isSwiping) {
  if (isQuickViewEnabled) {
  // Quick view is enabled - look for buttons in this order:
  // 1. Overlay button (single-image products)
  // 2. Quick-view-button (multi-variant products)  
  // 3. Title button (single variant multi-image products)
  const overlayBtn = productCard.querySelector('.product__card--quickview-trigger');
  const quickViewBtn = productCard.querySelector('.quick-view-button');
  const titleBtn = productCard.querySelector('.product__title--quickview-trigger');
  
  if (overlayBtn) {
    overlayBtn.click();
  } else if (quickViewBtn) {
    quickViewBtn.click();
  } else if (titleBtn) {
    titleBtn.click();
  }
} else if (productUrl) {
          // Quick view disabled - go to product page
          setTimeout(() => {
            window.location.href = productUrl;
          }, 50);
        }
      }
    });
  } else {
    // Non-touch device behavior
    slide.style.cursor = 'pointer';
    
    // Simple click handler for desktop (no drag conflicts since dragging is disabled)
    slide.addEventListener('click', function(e) {
      // Prevent navigation during slide animation
      if (!element.swiper.animating) {
    if (isQuickViewEnabled) {
  // Quick view is enabled - look for buttons in this order:
  // 1. Overlay button (single-image products)
  // 2. Quick-view-button (multi-variant products)  
  // 3. Title button (single variant multi-image products)
  const overlayBtn = productCard.querySelector('.product__card--quickview-trigger');
  const quickViewBtn = productCard.querySelector('.quick-view-button');
  const titleBtn = productCard.querySelector('.product__title--quickview-trigger');
  
  if (overlayBtn) {
    overlayBtn.click();
  } else if (quickViewBtn) {
    quickViewBtn.click();
  } else if (titleBtn) {
    titleBtn.click();
  }
} else if (productUrl) {
          // Quick view disabled - go to product page
          window.location.href = productUrl;
        }
      }
    });
  }
});
          },
          
          slideChange: function() {
            // Update progress line when slide changes (mobile only)
            updateProgressLine(this);
            
            // Track slide changes for analytics if needed
            if (window.theme && window.theme.trackProductImageSwipe) {
              window.theme.trackProductImageSwipe(productId, this.activeIndex);
            }
          },
          
          slideChangeTransitionEnd: function() {
            updateProgressLine(this);
          },
          
          // Prevent dragging on non-touch devices
          touchStart: function(e) {
            if (!isTouch) {
              e.preventDefault();
              return false;
            }
            this.touchStartTime = Date.now();
          },
          
          touchMove: function(e) {
            if (!isTouch) {
              e.preventDefault();
              return false;
            }
          },
          
          touchEnd: function(e) {
            if (!isTouch) {
              e.preventDefault();
              return false;
            }
            const touchDuration = Date.now() - this.touchStartTime;
            if (touchDuration < 200 && !this.touches.diff) {
              // This was a tap, not a swipe
            }
          },
          
          beforeResize: function() {
            this.params.width = this.el.getBoundingClientRect().width;
          },

          resize: function() {
            // Update configuration on resize
            const shouldLoop = !isMobileDevice();
            const newIsTouch = isTouchDevice();
            
            if (this.params.loop !== shouldLoop || this.params.allowTouchMove !== newIsTouch) {
              this.destroy();
              setTimeout(initializeProductCardSwipers, 100);
            }
          }
        }
      };
      
      // Initialize Swiper instance
      const swiper = new Swiper(element, swiperConfig);
      
      // Store swiper instance for later access
      element.swiperInstance = swiper;
      element.swiper = swiper; // Alternative reference
      element.classList.add('swiper-initialized');
      
      // Additional prevention for non-touch devices
      if (!isTouch) {
        // Prevent any drag events on the swiper container
        element.addEventListener('dragstart', function(e) {
          e.preventDefault();
          return false;
        });
        
        element.addEventListener('selectstart', function(e) {
          e.preventDefault();
          return false;
        });
        
        // Disable text selection
        element.style.userSelect = 'none';
        element.style.webkitUserSelect = 'none';
        element.style.mozUserSelect = 'none';
        element.style.msUserSelect = 'none';
      }
    });
  }

  // Fallback slider implementation (no Swiper library)
  function initializeFallbackSlider() {
    const sliderContainers = document.querySelectorAll('.product-card-swiper:not(.fallback-initialized)');
    
    sliderContainers.forEach(container => {
      container.classList.add('fallback-initialized');
      const productUrl = container.getAttribute('data-product-url');
      const wrapper = container.querySelector('.swiper-wrapper');
      const slides = container.querySelectorAll('.swiper-slide');
      const prevBtn = container.querySelector('.swiper-button-prev');
      const nextBtn = container.querySelector('.swiper-button-next');
      const sliderContainer = container.closest('.product-card-swiper-container');
      
      if (slides.length <= 1) {
        sliderContainer.style.display = 'none';
        return;
      }
      
      const isTouch = isTouchDevice();
      const isMobile = isMobileDevice();
      
      // Add device-specific classes
      if (isTouch) {
        sliderContainer.classList.add('touch-device');
      } else {
        sliderContainer.classList.add('no-touch-device');
      }
      
      let currentIndex = 0;
      
      // Setup fallback styles
      wrapper.style.display = 'flex';
      wrapper.style.transition = 'transform 0.3s ease';
      wrapper.style.transform = 'translateX(0)';
      
     slides.forEach((slide, index) => {
  slide.style.minWidth = '100%';
  slide.style.cursor = 'pointer';
  
  // Check if quick view toggle is enabled via data attribute
  const productCard = sliderContainer.closest('.product-grid-item');
  const isQuickViewEnabled = productCard && productCard.getAttribute('data-quickview-enabled') === 'true';
  
  if (isTouch) {
    // Touch device click handling with swipe detection
    let touchStartX = 0;
    let touchStartY = 0;
    let isSwiping = false;
    
    slide.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isSwiping = false;
    });
    
    slide.addEventListener('touchmove', function(e) {
      const diffX = Math.abs(e.touches[0].clientX - touchStartX);
      const diffY = Math.abs(e.touches[0].clientY - touchStartY);
      if (diffX > 10 || diffY > 10) {
        isSwiping = true;
      }
    });
    
    slide.addEventListener('touchend', function(e) {
      if (!isSwiping) {
     if (isQuickViewEnabled) {
  // Quick view is enabled - look for buttons in this order:
  // 1. Overlay button (single-image products)
  // 2. Quick-view-button (multi-variant products)  
  // 3. Title button (single variant multi-image products)
  const overlayBtn = productCard.querySelector('.product__card--quickview-trigger');
  const quickViewBtn = productCard.querySelector('.quick-view-button');
  const titleBtn = productCard.querySelector('.product__title--quickview-trigger');
  
  if (overlayBtn) {
    overlayBtn.click();
  } else if (quickViewBtn) {
    quickViewBtn.click();
  } else if (titleBtn) {
    titleBtn.click();
  }
} else if (productUrl) {
          // Quick view disabled - go to product page
          setTimeout(() => {
            window.location.href = productUrl;
          }, 50);
        }
      }
    });
  } else {
    // Non-touch device simple click
    slide.addEventListener('click', function(e) {
    if (isQuickViewEnabled) {
  // Quick view is enabled - look for buttons in this order:
  // 1. Overlay button (single-image products)
  // 2. Quick-view-button (multi-variant products)  
  // 3. Title button (single variant multi-image products)
  const overlayBtn = productCard.querySelector('.product__card--quickview-trigger');
  const quickViewBtn = productCard.querySelector('.quick-view-button');
  const titleBtn = productCard.querySelector('.product__title--quickview-trigger');
  
  if (overlayBtn) {
    overlayBtn.click();
  } else if (quickViewBtn) {
    quickViewBtn.click();
  } else if (titleBtn) {
    titleBtn.click();
  }
} else if (productUrl) {
        // Quick view disabled - go to product page
        window.location.href = productUrl;
      }
    });
  }
});
  
      
      // Create progress line for mobile only
      if (isMobile) {
        const progressLineContainer = document.createElement('div');
        progressLineContainer.className = 'swiper-progress-line';
        const progressLineFill = document.createElement('div');
        progressLineFill.className = 'swiper-progress-line-fill';
        progressLineContainer.appendChild(progressLineFill);
        container.appendChild(progressLineContainer);
      }
      
      // Hide original pagination if it exists
      const pagination = container.querySelector('.swiper-pagination');
      if (pagination) {
        pagination.style.display = 'none';
      }
      
      // Navigation functions
      function goToSlide(index) {
        // For desktop/tablet - infinite scroll
        if (!isMobile && slides.length > 1) {
          if (index < 0) {
            currentIndex = slides.length - 1;
          } else if (index >= slides.length) {
            currentIndex = 0;
          } else {
            currentIndex = index;
          }
        } else {
          // For mobile - no infinite scroll
          currentIndex = Math.max(0, Math.min(index, slides.length - 1));
        }
        
        wrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
        updateProgressLine();
      }
      
      // Progress line update function (mobile only)
      function updateProgressLine() {
        if (!isMobile) return;
        
        const progressLineFill = container.querySelector('.swiper-progress-line-fill');
        if (progressLineFill) {
          const indicatorWidth = 100 / slides.length;
          progressLineFill.style.width = indicatorWidth + '%';
          progressLineFill.style.transform = `translateX(${(currentIndex * 100)}%)`;
        }
      }
      
      // Initialize progress line
      updateProgressLine();
      
      // Navigation buttons (desktop/tablet only)
      if (prevBtn && !isMobile) {
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          goToSlide(currentIndex - 1);
        });
      }
      
      if (nextBtn && !isMobile) {
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          goToSlide(currentIndex + 1);
        });
      }
      
      // Touch swipe support (only for touch devices)
      if (isTouch) {
        let touchStartX = 0;
        let touchEndX = 0;
        
        container.addEventListener('touchstart', e => {
          touchStartX = e.changedTouches[0].screenX;
        });
        
        container.addEventListener('touchend', e => {
          touchEndX = e.changedTouches[0].screenX;
          handleSwipe();
        });
        
        function handleSwipe() {
          const swipeThreshold = 50;
          const diff = touchStartX - touchEndX;
          
          if (Math.abs(diff) > swipeThreshold) {
            if (diff > 0) {
              // Swipe left - next slide
              goToSlide(currentIndex + 1);
            } else if (diff < 0) {
              // Swipe right - previous slide
              goToSlide(currentIndex - 1);
            }
          }
        }
      } else {
        // Disable any drag/select functionality on non-touch devices
        container.addEventListener('dragstart', function(e) {
          e.preventDefault();
          return false;
        });
        
        container.addEventListener('selectstart', function(e) {
          e.preventDefault();
          return false;
        });
        
        container.style.userSelect = 'none';
        container.style.webkitUserSelect = 'none';
        container.style.mozUserSelect = 'none';
        container.style.msUserSelect = 'none';
      }
      
      // Handle window resize
      window.addEventListener('resize', function() {
        updateProgressLine();
      });
    });
  }
})();
})();
